// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6c85d72c","411":"8c85a675","453":"69b360b5","728":"cf3c9e37","766":"60bd0795","886":"e43946c4"}[chunkId] + ".chunk.js";
};